module.exports = __webpack_public_path__ + "img/luggage_2.6c0178bf.svg";